export default function ChatInboxIcon({
  className = "",
}: {
  className?: string;
}) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="7 7 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.99169 22.3417C9.13873 22.7126 9.17147 23.119 9.08569 23.5087L8.02069 26.7987C7.98638 26.9655 7.99525 27.1384 8.04647 27.3008C8.09769 27.4633 8.18955 27.61 8.31336 27.7269C8.43716 27.8439 8.5888 27.9274 8.75389 27.9693C8.91898 28.0113 9.09205 28.0104 9.25669 27.9667L12.6697 26.9687C13.0374 26.8957 13.4182 26.9276 13.7687 27.0607C15.9041 28.0579 18.323 28.2689 20.5988 27.6564C22.8746 27.0439 24.8609 25.6473 26.2074 23.713C27.5538 21.7788 28.1738 19.4311 27.958 17.0842C27.7421 14.7374 26.7044 12.5422 25.0277 10.8859C23.3511 9.22962 21.1434 8.21873 18.7941 8.03159C16.4447 7.84445 14.1048 8.49308 12.1871 9.86303C10.2694 11.233 8.89722 13.2362 8.31258 15.5193C7.72795 17.8024 7.96846 20.2186 8.99169 22.3417Z"
        stroke="currentColor"
        strokeWidth="1.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
